import { RackEvent } from 'libs/ui';

export const Error = (props) => {
  return <RackEvent {...props} icon="error.png" type="high" />;
};

export default Error;
